module.exports = __webpack_public_path__ + "media/images/certificado-2-6b1c1cae6a4b0bfbd5a0c97180ea7ab7.png";